
export default {
  name: "Blog",
  scrollToTop: true,
  async asyncData({ $content, params, error }) {
    const articles = await $content(`articles`)
      .sortBy("date", "desc")
      .fetch()
      .catch(() => {
        error({ statusCode: 404, message: "no articles found" });
      });

    return {
      articles,
    };
  },
  data() {
    return {
      dateOptions: {
        year: "numeric",
        month: "long",
        day: "numeric",
      },
    };
  },
  head() {
    return {
      title: this.$t("pageTitle.blog"),
      titleTemplate: "%s | INDOMASCOT",
      url: `https://www.indomascot.com${this.$route.path}`,
      description: this.$t("pageDescription.blog"),
      meta: [
        // hid is used as unique identifier. Do not use `vmid` for it as it will not work
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
      ],
    };
  },
};
